import { render } from "./InfoModal.vue?vue&type=template&id=d15416a0&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"

import "./InfoModal.vue?vue&type=style&index=0&id=d15416a0&scoped=true&lang=css"

import exportComponent from "/home/maeda/ocx/ocx-hikari-sale-screenview/self/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d15416a0"]])

export default __exports__